import {UyapRequest} from "./UyapRequest";

export interface EvrakGonderTalep {
    formData: true,
    data: FormData
}

export interface EvrakGonderCevap {
    type: string,
    message: string,
    log: string,
    value: string
}

export default class EvrakGonder extends UyapRequest<EvrakGonderTalep, EvrakGonderCevap> {
    getMethod(): "POST" | "GET" {
        return "POST";
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return {
            "type":"success",
            "message":"İnternet yoluyla göndermek istediğiniz evraklar onay için Bolu İcra Dairesi katiplerine [15477585633] iş emri numaralarıyla gönderildi. Bu iş emir numaraları ile İşlemlerim menüsünden evrakların durumunu takip edebilirsiniz. Onay işlemleri yapıldığı takdirde 2019/40813 nolu İcra Dosyasına eklediğiniz evrakları görebilirsiniz. ",
            "value":"[15477585633]",
            "log":""
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + "main/jsp/avukat/evrakGonder_brd.ajx";
    }

    async parse(data: any): Promise<EvrakGonderCevap> {
        return data;
    }
}

